import $ from 'jquery';

export const navMenuEventHandler = () => {
  const $menuBtn = $('#menuBtn');
  const $menuMobile = $('#menuMobile');
  const $menuDesktop = $('#menuDesktop');

  $menuBtn.off('click').on('click', () => {
    const visible = $menuMobile.is(':visible');

    $('body').css('overflow', visible ? '' : 'hidden');

    $menuBtn.toggleClass('on');

    if (visible) { // close
      $menuMobile.addClass('close')
      setTimeout(() => {
        $menuMobile.fadeOut(300).removeClass('on');
        setTimeout(() => {
          $menuMobile.removeClass('close');
        }, 500);
      }, 500);
    } else { // open
      window.scrollTo(0, 0);
      $menuMobile.fadeIn(300).addClass('on');
    }
  });

  const { pathname } = window.location;

  const checkLinkHref = function () {
    const $a = $(this);
    const reg = new RegExp($a.attr('href'));
    if (reg.test(pathname)) $a.parent().addClass('on');
  }

  $menuDesktop.find('a').each(checkLinkHref);
  $menuMobile.find('a').each(checkLinkHref);
}
